// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"33":"7edcafc9","72":"962679ac","238":"db03cbf8","372":"67852120","573":"f242ac6f","634":"6289b015","776":"824d8c19","779":"c059ea50"}[chunkId] + ".chunk.css";
};